import { forwardRef, type Ref, type SVGProps } from "react";
const IconPlusFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M18 18h10a2 2 0 0 0 0-4H18V4a2 2 0 0 0-4 0v10H4a2 2 0 0 0-2 2 2 2 0 0 0 2 2h10v10a2 2 0 0 0 2 2 2 2 0 0 0 2-2Z" /></svg>;
const ForwardRef = forwardRef(IconPlusFilledSVG);
ForwardRef.displayName = "IconPlusFilled";
export { ForwardRef as IconPlusFilled };